import { IconProps } from "@/components/Icons/index";

export const WorkerLogo: React.FC<IconProps> = (props) => (
  <img src="/assets/images/worker.png" alt="worker" {...props} />
);
